import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'view-mode-dialog',
    templateUrl: './view-mode-dialog.component.html',
    styleUrls: ['./view-mode-dialog.component.scss'],
    standalone: false
})
export class ViewModeDialog  {

  constructor (public dialogRef: MatDialogRef<ViewModeDialog>) { }

  onConfirm(): void {
    this.dialogRef.close()
  }
}